<h2>Application Shell</h2>
<p class="demo-description">Demonstrates <code>upp-application</code>, <code>upp-panel</code>, and <code>upp-header</code>.</p>

<!-- Controls -->
<div class="demo-controls">
    <ion-button size="small" (click)="toggleMenu()">Menu: {{ menuMode }}</ion-button>
    <ion-button size="small" (click)="cyclePanelSize()">Panel size: {{ panelSize }}</ion-button>
    <ion-button size="small" (click)="togglePanelLines()">Panel lines: {{ panelLines }}</ion-button>
    <ion-button size="small" (click)="toggleHeaderMenu()">Header menu: {{ headerMenu }}</ion-button>
    <ion-button size="small" *ngFor="let c of colors" [color]="c" (click)="headerColor = c">{{ c }}</ion-button>
</div>

<!-- upp-header demo -->
<div class="demo-section">
    <h3>upp-header</h3>
    <upp-header [color]="headerColor" [menu]="headerMenu" height="50px">
        <upp-header-title>Sample Header Title</upp-header-title>
        <upp-header-button>
            <ion-icon name="settings-outline"></ion-icon>
        </upp-header-button>
        <upp-header-button>
            <ion-icon name="notifications-outline"></ion-icon>
        </upp-header-button>
    </upp-header>
</div>

<!-- upp-panel demo -->
<div class="demo-section">
    <h3>upp-panel (size={{ panelSize }}, lines={{ panelLines }})</h3>
    <div style="height: 280px;">
        <upp-panel [size]="panelSize" [lines]="panelLines">
            <upp-panel-header>
                <ion-item lines="none">
                    <ion-label><strong>Panel Header</strong></ion-label>
                </ion-item>
            </upp-panel-header>
            <upp-panel-content>
                <ion-item lines="none">
                    <ion-label class="ion-text-wrap">
                        This is the panel content area. It supports any projected content.
                    </ion-label>
                </ion-item>
            </upp-panel-content>
            <upp-panel-footer>
                <ion-item lines="none">
                    <ion-label color="medium">Panel Footer</ion-label>
                </ion-item>
            </upp-panel-footer>
        </upp-panel>
    </div>
</div>

<!-- upp-application structure (visual only) -->
<div class="demo-section">
    <h3>upp-application structure (menu={{ menuMode }})</h3>
    <div style="height: 300px; border: 1px solid var(--ion-color-medium, #ccc); border-radius: 8px; overflow: hidden;">
        <upp-application [menu]="menuMode">
            <upp-application-menu>
                <ion-list>
                    <ion-item><ion-label>Menu Item 1</ion-label></ion-item>
                    <ion-item><ion-label>Menu Item 2</ion-label></ion-item>
                    <ion-item><ion-label>Menu Item 3</ion-label></ion-item>
                </ion-list>
            </upp-application-menu>
            <upp-application-main>
                <upp-header color="primary" menu="hide">
                    <upp-header-title>Application Main</upp-header-title>
                </upp-header>
                <div style="padding: 16px;">
                    <p>Main content area of the application shell.</p>
                </div>
            </upp-application-main>
            <upp-application-page>
                <div style="padding: 16px;">
                    <p>Page content (detail pane).</p>
                </div>
            </upp-application-page>
        </upp-application>
    </div>
</div>
